import { io } from "socket.io-client";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const socket = io(BACKEND_URL, {
  path: "/api/socket.io",
  // Reads token dynamically at connect time
  auth: (cb) => cb({ token: localStorage.getItem("pv_token") }),
  autoConnect: false,
  reconnectionAttempts: 8,
  reconnectionDelay: 1500,
  transports: ["websocket", "polling"],
});

export default socket;
